var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContactUsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 24L35 46L68 24M2 24L35 2L68 24M2 24V60.6667M68 24V60.6667M68 60.6667C68 62.6116 67.2274 64.4768 65.8521 65.8521C64.4768 67.2274 62.6116 68 60.6667 68H9.33333C7.38841 68 5.52315 67.2274 4.14788 65.8521C2.77262 64.4768 2 62.6116 2 60.6667M68 60.6667L46 38.6667M2 60.6667L24 38.6667",
    stroke: "#D2DAE4",
    strokeWidth: 2.51429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContactUsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contact-us-icon.6e7b785762874b78d85f084e1c8565be.svg";